export const Types = {
  INITIALIZE: 'uiBlog/INITIALIZE',
};

export const Actions = {
  initialize: () => ({
    type: Types.INITIALIZE,
  }),
};



// WEBPACK FOOTER //
// ./src/redux/ui/blog/actions.js